function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".sprinkle-icon{fill:url(#sprinkle);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "sprinkle",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "10%",
  stopColor: "#038FC7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#68C34F"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "sprinkle-icon",
  d: "M9,62h2h2c3.86,0,7-3.141,7-7c0-0.553-0.448-1-1-1h-2c-2.548,0-4.775,1.373-6,3.413C9.775,55.373,7.548,54,5,54H3  c-0.552,0-1,0.447-1,1C2,58.859,5.14,62,9,62z M17,56h0.899c-0.464,2.279-2.485,4-4.899,4h-0.899C12.565,57.721,14.585,56,17,56z   M5,56c2.415,0,4.435,1.721,4.899,4H9c-2.415,0-4.435-1.721-4.899-4H5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "sprinkle-icon",
  d: "M61,54h-2c-2.548,0-4.775,1.373-6,3.413C51.775,55.373,49.548,54,47,54h-2c-0.552,0-1,0.447-1,1c0,3.859,3.14,7,7,7h2h2  c3.86,0,7-3.141,7-7C62,54.447,61.552,54,61,54z M51,60c-2.415,0-4.435-1.721-4.899-4H47c2.415,0,4.435,1.721,4.899,4H51z M55,60  h-0.899c0.464-2.279,2.485-4,4.899-4h0.899C59.435,58.279,57.415,60,55,60z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "sprinkle-icon",
  d: "M40,29c0-0.553-0.448-1-1-1H25c-0.552,0-1,0.447-1,1c0,2.414,1.721,4.434,4,4.899V35c-0.552,0-1,0.447-1,1v25  c0,0.553,0.448,1,1,1h8c0.552,0,1-0.447,1-1V36c0-0.553-0.448-1-1-1v-1.101C38.279,33.434,40,31.414,40,29z M26.171,30h11.657  c-0.413,1.164-1.525,2-2.829,2h-6C27.696,32,26.584,31.164,26.171,30z M35,60h-6V37h6V60z M30,35v-1h4v1H30z"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 21.065,
  y: 32.644,
  transform: "matrix(0.3559 -0.9345 0.9345 0.3559 -17.2291 42.2894)",
  width: 2,
  height: 2
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 2.376,
  y: 25.524,
  transform: "matrix(0.3559 -0.9345 0.9345 0.3559 -22.6127 20.2378)",
  width: 2,
  height: 2
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 7.048,
  y: 27.304,
  transform: "matrix(0.3559 -0.9345 0.9345 0.3559 -21.2669 25.751)",
  width: 2,
  height: 2
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 16.393,
  y: 30.864,
  transform: "matrix(0.3559 -0.9345 0.9345 0.3559 -18.5748 36.7764)",
  width: 2,
  height: 2
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 11.721,
  y: 29.084,
  transform: "matrix(0.3559 -0.9345 0.9345 0.3559 -19.9213 31.264)",
  width: 2,
  height: 2
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 14.52,
  y: 11.432,
  transform: "matrix(0.8484 -0.5294 0.5294 0.8484 -4.2284 10.102)",
  width: 2,
  height: 2
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 22.47,
  y: 24.152,
  transform: "matrix(0.848 -0.53 0.53 0.848 -9.7625 16.2605)",
  width: 2.001,
  height: 2
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 17.17,
  y: 15.672,
  transform: "matrix(0.8479 -0.5302 0.5302 0.8479 -6.0751 12.1693)",
  width: 2,
  height: 1.999
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 19.82,
  y: 19.912,
  transform: "matrix(0.8479 -0.5302 0.5302 0.8479 -7.9201 14.2192)",
  width: 2,
  height: 1.999
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 54.952,
  y: 27.304,
  transform: "matrix(0.9345 -0.3559 0.3559 0.9345 -6.4102 21.7687)",
  width: 2,
  height: 2
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 45.607,
  y: 30.864,
  transform: "matrix(0.9345 -0.3559 0.3559 0.9345 -8.2892 18.6757)",
  width: 2,
  height: 2
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 59.624,
  y: 25.524,
  transform: "matrix(0.9345 -0.356 0.356 0.9345 -5.4708 23.321)",
  width: 2,
  height: 2
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 50.279,
  y: 29.084,
  transform: "matrix(0.9345 -0.3559 0.3559 0.9345 -7.3499 20.2223)",
  width: 2,
  height: 2
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 40.935,
  y: 32.644,
  transform: "matrix(0.9345 -0.3559 0.3559 0.9345 -9.2288 17.1293)",
  width: 2,
  height: 2
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 39.53,
  y: 24.152,
  transform: "matrix(0.5301 -0.8479 0.8479 0.5301 -2.2828 46.1842)",
  width: 2,
  height: 2.001
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 47.48,
  y: 11.432,
  transform: "matrix(0.5294 -0.8484 0.8484 0.5294 12.2665 46.9784)",
  width: 2,
  height: 2
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 44.83,
  y: 15.672,
  transform: "matrix(0.5304 -0.8478 0.8478 0.5304 7.3899 46.6835)",
  width: 1.999,
  height: 2
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 42.18,
  y: 19.912,
  transform: "matrix(0.5304 -0.8478 0.8478 0.5304 2.5506 46.4284)",
  width: 1.999,
  height: 2
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 13.068,
  y: 41.729,
  transform: "matrix(0.903 -0.4296 0.4296 0.903 -16.9906 10.1861)",
  width: 2,
  height: 2.001
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 17.583,
  y: 39.58,
  transform: "matrix(0.9027 -0.4303 0.4303 0.9027 -15.654 11.9464)",
  width: 2,
  height: 1.999
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 22.097,
  y: 37.431,
  transform: "matrix(0.9027 -0.4303 0.4303 0.9027 -14.2897 13.6798)",
  width: 2,
  height: 1.999
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 4.04,
  y: 46.029,
  transform: "matrix(0.9028 -0.4301 0.4301 0.9028 -19.739 6.741)",
  width: 2,
  height: 1.999
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 8.554,
  y: 43.879,
  transform: "matrix(0.903 -0.4296 0.4296 0.903 -18.3516 8.4555)",
  width: 2,
  height: 2.001
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 44.417,
  y: 39.58,
  transform: "matrix(0.4301 -0.9028 0.9028 0.4301 -10.7524 64.1253)",
  width: 1.999,
  height: 2
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 39.903,
  y: 37.43,
  transform: "matrix(0.4301 -0.9028 0.9028 0.4301 -11.3845 58.8252)",
  width: 1.999,
  height: 2
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 53.445,
  y: 43.879,
  transform: "matrix(0.4297 -0.903 0.903 0.4297 -9.4754 74.7543)",
  width: 2.001,
  height: 2
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 48.931,
  y: 41.73,
  transform: "matrix(0.4297 -0.903 0.903 0.4297 -10.1088 69.4526)",
  width: 2.001,
  height: 2
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  className: "sprinkle-icon",
  x: 57.96,
  y: 46.029,
  transform: "matrix(0.4301 -0.9028 0.9028 0.4301 -8.857 80.0265)",
  width: 1.999,
  height: 2
});

function SvgSprinkle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinkle);
export default __webpack_public_path__ + "static/media/sprinkle.c1694fbf.svg";
export { ForwardRef as ReactComponent };